import {
  IconButton,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { Product } from 'shared/types/quotes';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { ProductInputRow } from 'quoting/new-quote/table-input-rows/product-intput-row';
import { getProductRowKey } from 'quoting/new-quote/helpers';

const tableStyles: SxProps = {
  borderRadius: '4px',
  boxShadow: 'rgb(0 0 0 / 20%) 0px 2px 1px -1px',
  backgroundColor: '#f0f0f0',
};

const CellStyles: SxProps = {
  fontSize: {
    xs: '12px',
    sm: '14px',
  },
};

const CellStylesColored = (theme: Theme, priorSubmit: boolean): SxProps => ({
  ...CellStyles,
  ...(!priorSubmit && {
    fontWeight: 'bold',
    color: theme.palette.success.main
  })
});
interface AddProductTableProps {
  rows: Product[];
  isAbleToDeleteProducts?: boolean;
  handleAddRow: (newRow: Product) => void;
  handleRemoveRow: (row: Product) => void;
  dateSubmitted?: string | null;
}

export function AddProductTable({
  rows,
  isAbleToDeleteProducts = false,
  handleAddRow,
  handleRemoveRow,
  dateSubmitted
}: AddProductTableProps) {
  const theme = useTheme();

  const treatedCellStyles = (row: Product) => {
    if (!dateSubmitted || (!!dateSubmitted && rows.every(p => !row.createdDate || (!!p.createdDate && new Date(p.createdDate) <= new Date(dateSubmitted))))) {
      return { ...CellStyles };
    }
    return CellStylesColored(theme, !row.createdDate || (!!row.createdDate && new Date(row.createdDate) <= new Date(dateSubmitted)))
  };

  return (
    <TableContainer sx={tableStyles}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align='center' width='10%' sx={(theme) => ({ ...CellStyles })}>
              Total Quantity
            </TableCell>
            <TableCell align='center' width='10%' sx={CellStyles}>
              Min Order Qty
            </TableCell>
            <TableCell align='center' sx={CellStyles}>
              Model Name
            </TableCell>
            <TableCell align='center' sx={CellStyles}>
              Tag #
            </TableCell>
            <TableCell align='center' sx={CellStyles}>
              Model No. *
            </TableCell>
            <TableCell align='center' sx={CellStyles}>
              Requested Pricing
            </TableCell>
            <TableCell align='center' sx={CellStyles}>
              Color
            </TableCell>
            <TableCell align='center' sx={CellStyles}>
              Options
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={getProductRowKey(row)}>
              <TableCell align='center' sx={treatedCellStyles(row)}>
                {row.totalQty}
              </TableCell>
              <TableCell align='center' sx={treatedCellStyles(row)}>
                {row.minOrderQty}
              </TableCell>
              <TableCell align='center' sx={treatedCellStyles(row)}>
                {row.modelName}
              </TableCell>
              <TableCell align='center' sx={treatedCellStyles(row)}>
                {row.tag}
              </TableCell>
              <TableCell align='center' sx={treatedCellStyles(row)}>
                {row.modelNumber}
              </TableCell>
              <TableCell align='center' sx={treatedCellStyles(row)}>
                {row.requestedPrice}
              </TableCell>
              <TableCell align='center' sx={treatedCellStyles(row)}>
                {row.color}
              </TableCell>
              <TableCell align='center' sx={treatedCellStyles(row)}>
                {row.options}
              </TableCell>
              <TableCell sx={{ padding: { xs: '5px', md: '6px 16px' } }}>
                <Tooltip title={<Typography variant='body2'>Remove</Typography>}>
                  <IconButton onClick={() => handleRemoveRow(row)} disabled={!isAbleToDeleteProducts}>
                    <RemoveCircleIcon color={!isAbleToDeleteProducts ? 'disabled' : 'error'} />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
          <ProductInputRow handleAddRow={handleAddRow} />
        </TableBody>
      </Table>
    </TableContainer>
  );
}
